jQuery(function ($){

  showMap()

  function showMap () {

    function hideAllMaps() {
      $('.contact-card').removeClass('active');
    }

    $('.contact-card__btn').on('click', function() {

      if( $(this).closest('.contact-card').hasClass('active') ) {
        $(this).closest('.contact-card').removeClass('active')
      } else {
        hideAllMaps()
        $(this).closest('.contact-card').addClass('active')
      }

    });

    $('.contact-card__map-icon').on('click', function() {
      hideAllMaps();
    }
    
  )};

});